import { useEffect, useState, useRef } from "react"
import useApp from 'hooks/useApp'
import { SecureKeypad } from "components"
import { useLocation, useNavigate } from "react-router-dom"
import Lib from 'library'
import Native from "library/native"
import Global from 'library/Global';

const ChangePasswordPage = () => {

	//#region Variables
	const App = useApp()
	const navigate = useNavigate()
	const location = useLocation()
	const [infoParam, setInfoParam] = useState()

	const [title, setTitle] = useState("새 비밀번호를 입력해주세요.")
	const [warn, setWarn] = useState()
	const pass1 = useRef()
	const pass2 = useRef()

	const callback = module => {
		//console.log('ChangePasswordPage...>>>[설정>간편비밀번호 수정]');

		const info = module.get_sessionInfo()
		if (typeof pass1.current === "undefined") {
			pass1.current = info
			setTitle("비밀번호를 다시 한번 입력해주세요.")
			setWarn()
			module.refresh()
		} else {
			pass2.current = info

			Lib.post("/api/more/myinfo/upd/pw", {
				// pw: module.get_input(),
				// pwRe: module.get_input(),
				secId: pass1.current.sessionId,
				secId2: pass2.current.sessionId,
				secInput: pass1.current.input,
				secInput2: pass2.current.input,
				secToken: pass1.current.secToken,
				secToken2: pass2.current.secToken,
			}, () => {
				console.log("sucess")

				// module.close()
				if (App.user && App.user.mbId) {

					/*
					Native.execute("AppManager", "setAuthenticate", result => {
						const json = JSON.parse(result)
						if (json.result !== "Success") console.error(decodeURI(json.result))
					}, { userid: App.user.mbId })
					*/
				}
				App.showAlert({
					msg: "비밀번호가 변경되었습니다.<br />변경된 비밀번호로 다시 로그인해 주세요.",
					onOk: () => {
						module.close()
						App.logout(() => {
							App.closeAllLayers()
							navigate("/member/login")
						})
					}
				})
			}, data => { // 실패시
				console.log("failed")

				module.refresh()
				setTitle("비밀번호를 입력해 주세요.")
				setWarn(data.msg)
				pass1.current = undefined
				pass2.current = undefined
			})
		}
	}

	useEffect(() => {
		const set = {
			show: true,
			title: <></>,
			left: null,
			right: <i className="icon_close" onClick={()=>navigate("/")} />
		}
		App.setHeader(set)
		App.setShowNav(false)
		App.setMainClass("white")

		//setInfoParam(location.state?.info)
		//console.log(infoParam);
	}, [])

	return (
		<div className="padding">
			{/* <input type="hidden" id="input1" /> */}
			<SecureKeypad callback={callback} title={title} warn={warn} autoClose={false} />
		</div>
	)
}

export default ChangePasswordPage
